export const versionInfo = {
  major: 1,
  minor: 2,
 git_hash: 'da1e2f09'
};
